import { render, staticRenderFns } from "./AppNavBarTabs.vue?vue&type=template&id=e6b65482&scoped=true&"
import script from "./AppNavBarTabs.vue?vue&type=script&lang=js&"
export * from "./AppNavBarTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppNavBarTabs.vue?vue&type=style&index=0&id=e6b65482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b65482",
  null
  
)

export default component.exports